import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/services/client'
import type { Campania, CampaniasFilters } from '@/modules/cronograma/types/campania'

interface CampaniasResponse {
  count: number
  items: Campania[]
}

/**
 * Hook para obtener campañas del endpoint /multichannel/campanias/
 */
export function useCampanias(filters?: CampaniasFilters) {
  return useQuery({
    queryKey: ['campanias', filters],
    queryFn: async () => {
      const params = new URLSearchParams()

      if (filters) {
        if (filters.search) params.append('search', filters.search)
        if (filters.marca_principal_id) params.append('marca_principal_id', filters.marca_principal_id.toString())
        if (filters.marca_secundaria_id) params.append('marca_secundaria_id', filters.marca_secundaria_id.toString())
        if (filters.estado_envio) params.append('estado_envio', filters.estado_envio)
        if (filters.estado_contenido) params.append('estado_contenido', filters.estado_contenido)
        if (filters.estado_reporte) params.append('estado_reporte', filters.estado_reporte)
        if (filters.tipo) params.append('tipo', filters.tipo)
        if (filters.formato) params.append('formato', filters.formato)
        if (filters.asesor_id) params.append('asesor_id', filters.asesor_id.toString())
        if (filters.fecha_desde) params.append('fecha_desde', filters.fecha_desde)
        if (filters.fecha_hasta) params.append('fecha_hasta', filters.fecha_hasta)
        if (filters.orden) params.append('orden', filters.orden)
        if (filters.page) params.append('page', filters.page.toString())
        if (filters.page_size) params.append('page_size', filters.page_size.toString())
      }

      const queryString = params.toString()
      const url = `/multichannel/campanias/${queryString ? `?${queryString}` : ''}`

      const response = await apiClient.get<CampaniasResponse>(url)
      return response.data
    },
  })
}

/**
 * Hook para obtener todas las campañas sin paginación (para el calendario)
 */
export function useAllCampanias() {
  return useCampanias({ page_size: 1000 }) // Obtener muchas campañas para el calendario
}
